module.exports = __webpack_public_path__ + "static/img/Yilan_02.efe2cb03.jpg";